@use '../../styles/global' as *;
@use '../../styles/kol-alert-mixin' as *;
@use '../@shared/mixins' as *;

@layer kol-component {
	@include kol-alert;

	:host {
		display: flex;
		position: fixed;
		z-index: 200;
		max-width: 90vw;
		flex-direction: column;
	}

	.kol-toast-container {
		&__close-all {
			align-self: flex-end;
		}
	}
}
